import { useCallback, useEffect, useState } from "react";
import { getTradingOverview } from "../api/trading";

function useTradingOverview(refreshMs = 0) {
    const [overview, setOverview] = useState(null);
    const [error, setError] = useState("");
    const [updatedAt, setUpdatedAt] = useState(null);

    const load = useCallback(async () => {
        try {
            const response = await getTradingOverview();
            setOverview(response.data);
            setUpdatedAt(new Date());
            setError("");
        } catch {
            setError("자동매매 운영 데이터를 불러오지 못했습니다.");
        }
    }, []);

    useEffect(() => {
        load();
        if (!refreshMs) return undefined;
        const timer = setInterval(load, refreshMs);
        return () => clearInterval(timer);
    }, [load, refreshMs]);

    return { overview, error, updatedAt, reload: load };
}

export default useTradingOverview;
